import getSymbolFromCurrency from 'currency-symbol-map';
import { every, find, minBy } from 'lodash';

import i18n from '../i18n';
import { isChannelSubscriptionOnly } from './index';

const TYPE_RENT = 'rent';
const TYPE_SALE = 'sale';

const areRentAndBuyEnabled = (dealInfo) =>
  every(dealInfo, (info) => info.enabled);
const getActiveRentPlan = (dealInfo) =>
  find(dealInfo, (info) => info.type === TYPE_RENT && info.enabled);
const getActiveSalePlan = (dealInfo) =>
  find(dealInfo, (info) => info.type === TYPE_SALE && info.enabled);
const getChannelPlan = (dealInfo) => dealInfo[0];

const getBuyRentText = ({ dealInfo }, channelData = {}) => {
  if (isChannelSubscriptionOnly(channelData)) {
    const channelPlan = getChannelPlan(channelData.dealInfo);
    return i18n.t('ownership.status.subscription-only', {
      price: channelPlan.price,
      currency: getSymbolFromCurrency(channelPlan.currency),
    });
  }

  if (areRentAndBuyEnabled(dealInfo)) {
    const cheapestPlan = minBy(dealInfo, (info) => info.price);
    return i18n.t('ownership.status.buy-from', {
      price: cheapestPlan.price,
      currency: getSymbolFromCurrency(cheapestPlan.currency),
    });
  }

  const rentPlan = getActiveRentPlan(dealInfo);
  if (rentPlan) {
    return i18n.t('ownership.status.rent', {
      price: rentPlan.price,
      currency: getSymbolFromCurrency(rentPlan.currency),
    });
  }

  const salePlan = getActiveSalePlan(dealInfo);
  if (salePlan) {
    return i18n.t('ownership.status.buy', {
      price: salePlan.price,
      currency: getSymbolFromCurrency(salePlan.currency),
    });
  }

  return '';
};

export default getBuyRentText;
